import axios from 'axios'

import config from '../config'

const fleetview = axios.create({
  baseURL: config.fleetview_base_url
})

fleetview.interceptors.request.use((request) => {
  if (!request.headers.Authorization) {
    const raw = localStorage.getItem('@Softruck:token')
    if (raw) request.headers.Authorization = `Bearer ${raw}`
  }
  return request
})

export { fleetview }
